// Common
export const REQUEST_STATES = {
  IDLE: 'IDLE',
  PENDING: 'PENDING',
  FULFILLED: 'FULFILLED',
  REJECTED: 'REJECTED',
};

// Account / User Profiles
export const USER_PROFILE_TYPES = {
  COMPANY_REP: 'COMPANY_REP',
};

// Authentication
export { BLACKLISTED_DOMAINS } from './blacklistedDomains';

export const COUNTRY_DATA_MAP = {
  BD: { DEFAULT_TZ: 'Asia/Dhaka', NAME: 'BANGLADESH', ISO_CODE: 'BD', CALLING_CODE: '+880' },
  CA: { DEFAULT_TZ: 'America/Winnipeg', NAME: 'CANADA', ISO_CODE: 'CA', CALLING_CODE: '+1' },
  DE: { DEFAULT_TZ: 'Europe/Berlin', NAME: 'GERMANY', ISO_CODE: 'DE', CALLING_CODE: '+49' },
  HK: { DEFAULT_TZ: 'Asia/Hong_Kong', NAME: 'HONG KONG', ISO_CODE: 'HK', CALLING_CODE: '+852' },
  ID: { DEFAULT_TZ: 'Asia/Makassar', NAME: 'INDONESIA', ISO_CODE: 'ID', CALLING_CODE: '+62' },
  IE: { DEFAULT_TZ: 'Europe/Dublin', NAME: 'IRELAND', ISO_CODE: 'IE', CALLING_CODE: '+353' },
  IL: { DEFAULT_TZ: 'Asia/Jerusalem', NAME: 'ISRAEL', ISO_CODE: 'IL', CALLING_CODE: '+972' },
  IN: { DEFAULT_TZ: 'Asia/Kolkata', NAME: 'INDIA', ISO_CODE: 'IN', CALLING_CODE: '+91' },
  JP: { DEFAULT_TZ: 'Asia/Tokyo', NAME: 'JAPAN', ISO_CODE: 'JP', CALLING_CODE: '+81' },
  MY: { DEFAULT_TZ: 'Asia/Kuala_Lumpur', NAME: 'MALAYSIA', ISO_CODE: 'MY', CALLING_CODE: '+60' },
  NP: { DEFAULT_TZ: 'Asia/Kathmandu', NAME: 'NEPAL', ISO_CODE: 'NP', CALLING_CODE: '+977' },
  NL: { DEFAULT_TZ: 'Europe/Amsterdam', NAME: 'NETHERLANDS', ISO_CODE: 'NL', CALLING_CODE: '+31' },
  QA: { DEFAULT_TZ: 'Asia/Qatar', NAME: 'QATAR', ISO_CODE: 'QA', CALLING_CODE: '+974' },
  PH: { DEFAULT_TZ: 'Asia/Manila', NAME: 'PHILIPPINES', ISO_CODE: 'PH', CALLING_CODE: '+63' },
  SG: { DEFAULT_TZ: 'Asia/Singapore', NAME: 'SINGAPORE', ISO_CODE: 'SG', CALLING_CODE: '+65' },
  LK: { DEFAULT_TZ: 'Asia/Colombo', NAME: 'SRI LANKA', ISO_CODE: 'LK', CALLING_CODE: '+94' },
  TH: { DEFAULT_TZ: 'Asia/Bangkok', NAME: 'THAILAND', ISO_CODE: 'TH', CALLING_CODE: '+66' },
  AE: { DEFAULT_TZ: 'Asia/Dubai', NAME: 'UNITED ARAB EMIRATES', ISO_CODE: 'AE', CALLING_CODE: '+971' },
  GB: { DEFAULT_TZ: 'Europe/London', NAME: 'UNITED KINGDOM', ISO_CODE: 'GB', CALLING_CODE: '+44' },
  US: { DEFAULT_TZ: 'US/Central', NAME: 'UNITED STATES', ISO_CODE: 'US', CALLING_CODE: '+1' },
};

export const SUPPORTED_COUNTRY_ISO_CODES = [
  'BD',
  'CA',
  'DE',
  'HK',
  'ID',
  'IE',
  'IL',
  'IN',
  'JP',
  'MY',
  'NP',
  'NL',
  'QA',
  'PH',
  'SG',
  'LK',
  'TH',
  'AE',
  'GB',
  'US',
];

// Company Rep Onboarding
export const COMPANY_TYPE_CHOICES = {
  B2B: 'Business to Business',
  B2C: 'Business to Consumer',
};

export const INDUSTRY_CHOICES = {
  FINTECH: 'Fintech',
  INSURANCE_TECH: 'Insurance Tech',
  HEALTH_TECH: 'Health Tech',
  LIFE_SCIENCES: 'Life Sciences',
  ENERGY_TECH: 'Energy Tech',
  GAMING: 'Gaming',
  EDTECH: 'Edtech',
  TRAVEL_AND_HOSP_TECH: 'Travel and Hospitality Tech',
  REAL_ESTATE_AND_CONSTRUCTION_TECH: 'Real Estate and Construction Tech',
  FOOD_AND_AGRICULTURE_TECH: 'Food & Agriculture Tech',
  AUTO_TECH: 'Auto Tech',
  MEDIA_AND_ENTERTAINMENT: 'Media & Entertainment',
  TRANSPORT_AND_LOGISTICS_TECH: 'Transportation & Logistics Tech',
  INDUSTRIAL_GOODS_AND_MANUFACTURING: 'Industrial Goods & Manufacturing',
  ENVIRONMENT_TECH: 'Environment Tech',
  BLOCKCHAIN_TECH: 'Blockchain Technology',
  E_COMMERCE: 'E-Commerce',
  GIG_ECONOMY: 'Gig Economy',
  ENTERPRISE_APPLICATIONS: 'Enterprise Applications',
  HR_AND_RECRUITMENT: 'HR & Recruitment',
  DATING_AND_MATCHMAKING: 'Dating & Matchmaking',
  SOCIAL_NETWORKING: 'Social Networking',
  INTERNET_FIRST_BRANDS: 'Internet-first brands',
};

export const FUNDING_STAGE_CHOICES = {
  BOOTSTRAPPED: 'Bootstrapped',
  SEED_ROUND: 'Seed Round',
  PRE_SERIES_C: 'Early Stage (Pre Series C)',
  POST_SERIES_C: 'Late Stage (Series C and Above)',
  PUBLIC: 'Public',
  ACQUIRED: 'Acquired',
};

export const EMPLOYEES_COUNT_CHOICES = {
  UPTO_TEN: '1-10',
  UPTO_FIFTY: '11-50',
  UPTO_TWO_HUNDRED: '51-200',
  UPTO_FIVE_HUNDRED: '201-500',
  UPTO_THOUSAND: '501-1000',
  UPTO_FIVE_THOUSAND: '1001-5000',
  UPTO_TEN_THOUSAND: '5001-10000',
  ABOVE_TEN_THOUSAND: '10000+',
};

export const PRODUCT_TEAM_SIZE_CHOICES = {
  UPTO_FIVE: '1-5',
  UPTO_TEN: '6-10',
  UPTO_TWENTY: '11-20',
  UPTO_FIFTY: '21-50',
  UPTO_HUNDRED: '51-100',
  UPTO_TWO_HUNDRED: '101-200',
  ABOVE_TWO_HUNDRED: '200+',
};

export const COMPANY_ROLE_CHOICES = {
  HEAD_OF_PRODUCT: 'Head of Product',
  PRODUCT_HIRING_MANAGER: 'Product Hiring Manager',
  PRODUCT_TEAM_MEMBER: 'Product Team Member',
  HEAD_OF_HR: 'Head of Human Resource',
  HR: 'Human Resource',
  FOUNDER_CXO: 'Founder/CXO',
  OTHER: 'Other',
};

export const COMPANY_REP_VERIFICATION_STATUSES = {
  UNVERIFIED: 'UNVERIFIED',
  IN_MANUAL_VERIFICATION: 'IN_MANUAL_VERIFICATION',
  VERIFICATION_FAILED: 'VERIFICATION_FAILED',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const COMPANY_VERIFICATION_STATUSES = {
  UNVERIFIED: 'UNVERIFIED',
  IN_MANUAL_VERIFICATION: 'IN_MANUAL_VERIFICATION',
  VERIFICATION_FAILED: 'VERIFICATION_FAILED',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

// Candidates
export const EMBARK_TRACKS = {
  ANALYTICS: { value: 'ANALYTICS', label: 'Analytics', color: '#95169F' },
  BUSINESS_OPERATIONS: { value: 'BUSINESS_OPERATIONS', label: 'Business Operations', color: '#6443c5' },
  DESIGN: { value: 'DESIGN', label: 'Design', color: '#137d6a' },
  PEOPLE_OPERATIONS: { value: 'PEOPLE_OPERATIONS', label: 'People Operations', color: '#897d0d' },
  PRODUCT_AND_GROWTH: { value: 'PRODUCT_AND_GROWTH', label: 'Product & Growth', color: '#266ea3' },
};

export const NON_UPRAISED_ROLE_CATEGORIES = {
  PRODUCT_MANAGEMENT: { value: 'Product Management', label: 'Product Management' },
  TECHNOLOGY: { value: 'Technology', label: 'Technology' },
  SALES_AND_MARKETING: { value: 'Sales & Marketing', label: 'Sales & Marketing' },
  ANALYTICS: { value: 'Analytics', label: 'Analytics' },
  OPERATIONS: { value: 'Operations', label: 'Operations' },
  DESIGN: { value: 'Design', label: 'Design' },
  OTHER: { value: 'Other', label: 'Other' },
};
